// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Bdq4","label":"SetPasswdForm_label__AqLd5"};